var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"save-default-button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('i',{staticClass:"mdi mdi-content-save-outline"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }